import React from "react"
import {Link } from "gatsby"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import { StaticQuery, graphql } from "gatsby"
import { Remarkable } from 'remarkable';
var md = new Remarkable();

const News = () => (

    <StaticQuery query={Newsquery} render={data=>{
        console.log(data)


        return (  
        <div>
            <Layout>
                <SEO title="News" />            
        

        <section id="slider" class="hero p-0 odd featured">
            <div class="swiper-container no-slider animation slider-h-50 slider-h-auto">
                
                <div class="swiper-wrapper">
                    <div class="swiper-slide slide-center">
                        {/* <img src="assets/images/bg-wide.jpg" alt="Full Image" class="full-image" data-mask="80"/> */}
                        <div class="slide-content row text-center">
                            <div class="col-12 mx-auto inner">
                                <h1 class="mb-0 title effect-static-text">News</h1>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </section>

        <section id="result" class="section-1 offers">
            <div class="container">
            
            <div class="row items">
            {data.allMarkdownRemark.edges.map((tag,index) => (
                

                <div class="col-12 col-md-4 item" style={{height: "100%"}}>
                    <Link to={tag.node.fields.slug} style={{float: "right"}}>
                    <div class="card" style={{padding:"15px"}}>
                        <div class="col-12">
                            <Link to={tag.node.fields.slug}>
                                <img src={tag.node.frontmatter.image} style={{height:"200px"}} alt="Logo" class="logo" class="fit-image"/>
                                <h4>{tag.node.frontmatter.title}</h4>
                                {/* <div dangerouslySetInnerHTML={{__html:md.render(tag.node.frontmatter.description.substring(0,100))}}></div> */}
                                
                                {/* <Link to={tag.node.fields.slug} style={{float: "right"}}>Read more</Link> */}
                                <div style={{textAlign: "right"}}>Read more</div>
                            </Link>
                        </div>
                    </div></Link>
                </div>
             
             ))}
              
            </div>
            
            </div>
        </section>


       
        </Layout>
            
            
            
            </div>
        )
    }}/>
    )

  const Newsquery = graphql`
  query newsindex{
    allMarkdownRemark(filter: {fileAbsolutePath: {regex: "posts/news_and_events/news/"}} 
    ) {
      edges {
        node {
          id
          frontmatter {
            title
            description
            image
          }
          fields{
            slug
          }
          
        }
      }
    }
  }
  
   `



  
export default News